var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 134,
    viewBox: "0 0 335 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.44 12.06C229.1 12.06 234.5 6.66056 234.5 0H310.88C324.201 0 335 10.7989 335 24.12V109.88C335 123.201 324.201 134 310.88 134H234.5C234.5 127.34 229.1 121.94 222.44 121.94C215.78 121.94 210.38 127.34 210.38 134H24.12C10.7989 134 0 123.201 0 109.88V24.12C0 10.7989 10.7989 0 24.12 0H210.38C210.38 6.66056 215.78 12.06 222.44 12.06ZM223.78 20.569C223.78 20.199 223.48 19.899 223.11 19.899C222.74 19.899 222.44 20.199 222.44 20.569V33.835C222.44 34.205 222.74 34.505 223.11 34.505C223.48 34.505 223.78 34.205 223.78 33.835V20.569ZM223.78 47.101C223.78 46.731 223.48 46.431 223.11 46.431C222.74 46.431 222.44 46.731 222.44 47.101V60.367C222.44 60.737 222.74 61.037 223.11 61.037C223.48 61.037 223.78 60.737 223.78 60.367V47.101ZM223.78 73.633C223.78 73.2632 223.48 72.963 223.11 72.963C222.74 72.963 222.44 73.2632 222.44 73.633V86.899C222.44 87.2688 222.74 87.569 223.11 87.569C223.48 87.569 223.78 87.2688 223.78 86.899V73.633ZM223.78 100.165C223.78 99.7952 223.48 99.495 223.11 99.495C222.74 99.495 222.44 99.7952 222.44 100.165V113.431C222.44 113.801 222.74 114.101 223.11 114.101C223.48 114.101 223.78 113.801 223.78 113.431V100.165Z",
    fill: "url(#paint0_linear_9_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2",
    x1: 335,
    y1: 0.0000279546,
    x2: -0.00000958443,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 134,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBackgroundMobile);
export default __webpack_public_path__ + "static/media/summary_background_mobile.ce98ca30298c6bdeb0c94b51251d28b6.svg";
export { ForwardRef as ReactComponent };